import { useEffect, useState, useRef } from "react";
import proxy from "../../utils/Proxy";
import { pressEnter } from "../../utils/Utils";
import UserSelectorDropdown from "./UserSelectorDropdown";
import "../../css/element/UserSelector.css"

let UserSelector = (props) => {
    let selectorRef = useRef(null)

    let [userList, setUserList] = useState([]);
    let [dropdownOpened, setDropdownOpened] = useState(false);

    let onSearchClick = () => {
        let params = {};
        params.name = document.getElementById("user-selector-username-input").value
        params.contact = document.getElementById("user-selector-contact-input").value

        proxy.get("/adminapi/users", {params: params}).then(res => {
            let list = res.data.data;
            setUserList(list);
            setDropdownOpened(true)
        });
    }
    const mouseDownHandler = (e) => {
        if (!selectorRef.current.contains(e.target)) {
            setDropdownOpened(false)
        }
    }
    let onClickResult = (userid, username) => {
        props.onClickResult(userid, username)
        setDropdownOpened(false)
    }
    useEffect(() => {
        document.addEventListener('mousedown', mouseDownHandler)
        return () => {
            document.removeEventListener('mousedown', mouseDownHandler)
        }
    })

    return (
        <div className="user-selector" ref={selectorRef}>
            <input id="user-selector-username-input"
                className="user-selector-search-input"
                placeholder="이름"
                onKeyDown={(e)=>pressEnter(e, onSearchClick)}/>
            <input id="user-selector-contact-input"
                className="user-selector-search-input"
                placeholder="전화번호" 
                onKeyDown={(e)=>pressEnter(e, onSearchClick)} />
            <div id="user-selector-search-button" onClick={onSearchClick}/>
            {dropdownOpened ?
                <UserSelectorDropdown
                    onClickResult={onClickResult}
                    userList={userList}>
                </UserSelectorDropdown> : null}
        </div>
    )
}
export default UserSelector;